export const GET_LEADERS = 'GET_LEADERS';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const EDIT_USER_PROFILE = 'EDIT_USER_PROFILE';
